<div class="modal-header">
  <h4 class="modal-title">{{'header.options.settings' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-xh" maxHeightOffset>
    <p>{{'global.label.choiceActionComponents' | translate}}</p>
    <div class="ps-5">
      <div class="form-check">
        <input type="radio" class="form-check-input" id="radio1" name="radioGroup" [value]="types[0]" [(ngModel)]="actionType"
               [disabled]="numberDisabled">
        <label class="form-check-label" for="radio1" [innerHTML]="'<b>'+('editArticleNumberMappingPopup.title' | translate) + '</b><br><span>' + ('ChoiceActionSetting.label.edit_article_numbers' | translate) + '</span>'"></label>
      </div>
      <div class="form-check mt-4">
        <input type="radio" class="form-check-input" id="radio2" name="radioGroup" [value]="types[1]" [(ngModel)]="actionType"
               [disabled]="numberDisabled">
        <label class="form-check-label" for="radio2" [innerHTML]="'<b>'+('favoriteArticlesOrderPopup.title' | translate) + '</b><br><span>' + ('ChoiceActionSetting.label.favorite_articles_order' | translate) + '</span>'"></label>
      </div>
      <div class="form-check mt-4">
        <input type="radio" class="form-check-input" id="radio3" name="radioGroup" [value]="types[2]" [(ngModel)]="actionType"
               [disabled]="optionsDisabled">
        <label class="form-check-label" for="radio3" [innerHTML]="'<b>'+('changeProjectOptionDefPopup.title' | translate) + '</b><br><span>' + ('ChoiceActionSetting.label.user_option' | translate) + '</span>'"></label>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
  <button class="btn btn-primary btn-forward" (click)="onConfirm()">{{'global.label.next' | translate}}</button>
</div>
